// The Add note popup (spec C7.4, S14, Renewals board): the list row menu and the Quick view open
// it. Title, the usual subline, a text box, Cancel left and Add note right. No confirm.
import { useState } from 'react';
import type { Api, RenewalRow } from '../auth/api';
import { Dialog } from '../shell/Dialog';
import { noteMax, noteReady, saveNote, type NoteUndo } from './notes-lines';

export function AddNoteDialog({
  api,
  row,
  onClose,
  onAdded,
}: {
  api: Api;
  row: RenewalRow;
  onClose: () => void;
  onAdded: (toast: string, undo: NoteUndo) => void;
}) {
  const [typed, setTyped] = useState('');
  const [busy, setBusy] = useState(false);
  const [failed, setFailed] = useState<string | null>(null);
  const text = noteReady(typed);
  const subline = [row.insured, row.carrier ?? 'Carrier', row.line, row.policyNumber]
    .filter(Boolean)
    .join(' | ');

  const add = async () => {
    if (!text) return;
    setBusy(true);
    setFailed(null);
    const res = await saveNote(api, row.id, text);
    setBusy(false);
    if (res.ok) onAdded(res.toast, res.undo);
    else setFailed(res.error);
  };

  return (
    <Dialog
      id="note-t"
      title="Add note"
      subline={subline}
      onClose={onClose}
      footer={
        <>
          <button type="button" className="btn" onClick={onClose}>
            Cancel
          </button>
          <button
            type="button"
            className={text ? 'btn btn-primary ml-auto' : 'btn ml-auto'}
            disabled={!text || busy}
            onClick={() => void add()}
          >
            Add note
          </button>
        </>
      }
    >
      <div className="col g4">
        <label htmlFor="note-text" className="flab">
          Note
        </label>
        <textarea
          id="note-text"
          className="input"
          maxLength={noteMax}
          value={typed}
          onChange={(e) => setTyped(e.target.value)}
        />
        {failed && <p className="errl m0">{failed}</p>}
      </div>
    </Dialog>
  );
}
